import { connect } from 'react-redux';

/* Styled Components */
import {
  FormSection,
  PageSubtitle,
  ImageContainer,
  Image,
} from 'styles/signup/MultiScreenSignupPage';

/* Child Components */
import SectionHeader from 'components/signup/multiscreen/SectionHeader';

/* Actions */
import { setCurrentSignupStep as setCurrentSignupStepAction } from 'app/signupSlice';

/* Utils */
import { i18n } from 'utils/i18n';

/* Constants */
import { SIGNUP_SCREEN } from 'constants/SignupConstants';

/* Types */
import type { AppDispatch } from 'app/store';

/* Assets */
import RetailStorefrontImage from 'assets/RetailStorefront.png';

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setCurrentSignupStep: (signupStep: Values<typeof SIGNUP_SCREEN>) =>
    dispatch(setCurrentSignupStepAction(signupStep)),
});

type PropsType = ReturnType<typeof mapDispatchToProps>;

const UnsupportedStoreTypePage = ({ setCurrentSignupStep }: PropsType) => {
  return (
    <>
      <SectionHeader
        title={i18n("We're sorry!")}
        onBackClicked={() => {
          setCurrentSignupStep(SIGNUP_SCREEN.STORE_TYPE);
        }}
      />
      <FormSection>
        <FormSection flex>
          <ImageContainer margin="0 0 32px 0">
            <Image src={RetailStorefrontImage} width="50%" />
          </ImageContainer>
        </FormSection>
        <PageSubtitle center>
          {i18n(
            'Unfortunately, you must have a brick and mortar store in a non-residential area to participate in the program.',
          )}
        </PageSubtitle>
      </FormSection>
    </>
  );
};

export default connect(null, mapDispatchToProps)(UnsupportedStoreTypePage);
